/**
 * Capital One Shopping: Save Now
 *
 * Every WAR entry is a directory glob (`css/*`, `notifications/*`), so the probes use
 * concrete paths resolved from the CRX. Both targets are feature-named rather than
 * build-hashed.
 *
 * Manifest verified against version 0.1.1379.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'nenlahapcbofgnanklpelkaejcehkggg';

export const capitalOneShopping: ExtensionDefinition = {
  id: ID,
  name: 'Capital One Shopping: Save Now',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 10_000_000,
  notes: 'Exposes whole directories by glob; probes target resolved filenames.',
  signals: [
    {
      id: 'war-sidepanel-css',
      kind: 'web-accessible-resource',
      description: 'Fetch css/sidePanelChat.css, matched by the css/* grant to <all_urls>.',
      weight: 1,
      run: () => probeFetch(ID, 'css/sidePanelChat.css'),
    },
    {
      id: 'war-cashback-injector',
      kind: 'web-accessible-resource',
      description:
        'Fetch notifications/injectors/apps/cashback.js — the cashback injector, ' +
        'matched by the notifications/* grant.',
      weight: 0.5,
      run: () => probeFetch(ID, 'notifications/injectors/apps/cashback.js'),
    },
  ],
};
